import { useContext, useMemo } from "react";
import { AlertContext, ShowAlert, HideAlert } from "./context/AlertContext";

/**
 * Provides methods for the showing/hiding of alerts
 * @returns A tuple containing a function for showing and hiding an alert.
 * @deprecated Please use the component in `capitalrx-components-2.0/lib/general`.
 */
export function useAlert(): [ShowAlert, HideAlert] {
  const { showAlert, hideAlert } = useContext(AlertContext);

  return useMemo((): [ShowAlert, HideAlert] => {
    return [showAlert, hideAlert];
  }, [showAlert, hideAlert]);
}
